/**
 * Dunning levels exposed via the JWT `f` flags.
 *
 * Behaviour per AuthLock Reasons (Confluence: ENG/AuthLock+Reasons):
 *  - dl1: payment overdue, email reminder sent. Web access **unrestricted** —
 *         show a banner only.
 *  - dl2: account suspended for non-payment. Web access restricted to the
 *         payment update page so the user can resolve the issue.
 *  - dl3: contract cancelled. Web behaviour TBD (TVFUS-60690) — the auth
 *         service may stop issuing web JWTs entirely. Not handled here until
 *         the spec is final.
 */
const DL1 = 'dl1';
const DL2 = 'dl2';

export function hasDunningLock(flags: readonly string[] | null | undefined): boolean {
  return flags?.includes(DL2) ?? false;
}

/**
 * Mutually exclusive with `hasDunningLock`: a locked user is already redirected
 * to the payment page, so showing the warning banner on top would be noisy.
 * Backend should never emit dl1 together with dl2, but we defend in depth.
 */
export function hasDunningWarning(flags: readonly string[] | null | undefined): boolean {
  return (flags?.includes(DL1) ?? false) && !hasDunningLock(flags);
}
